import { PropsWithChildren } from "react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Text } from "components/text";

export const SettingsLayout = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation("settings");

  return (
    <div className="h-screen grid grid-cols-[244px_1fr] divide-x divide-secondary-100 -mx-16 -my-8">
      <div className="bg-secondary-25 px-4 py-6">
        <div className="sticky top-5 space-y-1">
          <Text as="div" variant="caption" className="ml-1">
            {t("settings:navigation.title")}
          </Text>
          <nav className="grid grid-cols-1">
            <Link
              to="/settings/organisations"
              className="p-2 rounded-md text-sm font-medium"
              activeProps={{ className: "bg-secondary-50" }}
            >
              {t("settings:navigation.items.organisations.title")}
            </Link>
          </nav>
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
};
